<template>
  <b-card>
    <!-- form -->
    <validation-observer
      ref="updateBillingInfoForm"
      #default="{invalid}"
    >
      <b-form class="mt-2" @submit.prevent="saveInfo">
        <b-row>
          <b-col sm="6">
            <b-form-group
                :label="$t('Name/Company name')"
                label-for="name"
              >
                <validation-provider
                  #default="{ errors, failedRules }"
                  name="Name"
                  vid="name"
                  rules=""
                >
                <b-form-input
                  v-model="optionsLocal.name"
                  :state="errors.length > 0 ? false:null"
                  :placeholder="$t('Name')"
                  name="name"
                />
                <small class="text-danger" v-if="errors.length">{{ $t(`validation.${Object.keys(failedRules)[0]}`, {'_field_':$t('Name')}) }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
        <br />
        <h6 class="mx-1 mb-2">
            {{ $t('Billing address') }}
          </h6>
        <b-row>
          <b-col sm="6">
            <b-form-group>
              <validation-provider
                #default="{ errors, failedRules }"
                name="country"
                vid="country"
                rules=""
              >
                <country-select v-model="optionsLocal.address.country" :country="optionsLocal.address.country" topCountry="US" :usei18n="false" class="form-control" />
                <small class="text-danger" v-if="errors.length">{{ $t(`validation.${Object.keys(failedRules)[0]}`, {'_field_':$t('Country')}) }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group>
                <validation-provider
                  #default="{ errors, failedRules }"
                  name="address-line-1"
                  vid="address-line-1"
                  rules=""
                >
                <b-form-input
                  v-model="optionsLocal.address.line1"
                  :state="errors.length > 0 ? false:null"
                  :placeholder="$t('Address line 1')"
                  name="address-line-1"
                />
                <small class="text-danger" v-if="errors.length">{{ $t(`validation.${Object.keys(failedRules)[0]}`, {'_field_':$t('Address line 1')}) }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group>
                <validation-provider
                  #default="{ errors, failedRules }"
                  name="address-line-2"
                  vid="address-line-2"
                  rules=""
                >
                <b-form-input
                  v-model="optionsLocal.address.line2"
                  :state="errors.length > 0 ? false:null"
                  :placeholder="$t('Address line 2')"
                  name="address-line-2"
                />
                <small class="text-danger" v-if="errors.length">{{ $t(`validation.${Object.keys(failedRules)[0]}`, {'_field_':$t('Address line 2')}) }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group>
                <validation-provider
                  #default="{ errors, failedRules }"
                  name="city"
                  vid="city"
                  rules=""
                >
                <b-form-input
                  v-model="optionsLocal.address.city"
                  :state="errors.length > 0 ? false:null"
                  :placeholder="$t('City')"
                  name="city"
                />
                <small class="text-danger" v-if="errors.length">{{ $t(`validation.${Object.keys(failedRules)[0]}`, {'_field_':$t('City')}) }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          
          <b-col sm="6">
            <b-form-group>
              <validation-provider
                #default="{ errors, failedRules }"
                name="state"
                vid="state"
                rules=""
              >
                <region-select :disabled="optionsLocal.address.country === null" v-model="optionsLocal.address.state" :country="optionsLocal.address.country" :region="optionsLocal.address.state" :usei18n="false" class="form-control" placeholder="Select State" />
                <small class="text-danger" v-if="errors.length">{{ $t(`validation.${Object.keys(failedRules)[0]}`, {'_field_':$t('State')}) }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group>
                <validation-provider
                  #default="{ errors, failedRules }"
                  name="postcode"
                  vid="postcode"
                  rules=""
                >
                <b-form-input
                  v-model="optionsLocal.address.postal_code"
                  :state="errors.length > 0 ? false:null"
                  :placeholder="$t('Postcode')"
                  name="postcode"
                />
                <small class="text-danger" v-if="errors.length">{{ $t(`validation.${Object.keys(failedRules)[0]}`, {'_field_':$t('Postcode')}) }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
        
        <b-row>
          <b-col sm="6">
            <div class="d-flex justify-content-between">
              <label for="email">{{ $t('Email') }}</label>
            </div>
            <validation-provider
              #default="{ errors, failedRules }"
              name="Email"
              vid="email"
              rules="email"
            >
              <b-form-input
                disabled
                v-model="optionsLocal.email"
                :state="errors.length > 0 ? false:null"
                name="email"
                placeholder="john@example.com"
              />
              <small class="text-danger" v-if="errors.length">{{ $t(`validation.${Object.keys(failedRules)[0]}`, {'_field_':'Email'}) }}</small>
            </validation-provider>
          </b-col>
          <b-col sm="6">
            <div class="d-flex justify-content-between">
              <label for="phone">{{ $t('Mobile Phone') }}</label>
            </div>
              <input class="form-control" id="phonestripe" ref="phoneInput">
          </b-col>
        </b-row>
        <br /><br />
        <h6 class="mx-1 mb-2">
          {{ $t('Tax ID') }}
        </h6>
        <b-row>

          <b-col sm="6">
            <b-form-group
              :label="$t('Tax Type')"
              label-for="tax"
            >
              <validation-provider
                #default="{ errors, failedRules }"
                name="Tax"
                vid="tax"
                rules=""
              >
                <vue-select
                  v-model="taxType"
                  :reduce="option => option.value"
                  :filter="fuseSearch"
                  :options="taxOptions"
                  name="tax"
                  :get-option-label="(option) => option.description"
                  :state="errors.length > 0 ? false:null"
                  :class="errors.length>0 ? 'form-control is-invalid':null"
                >
                <template #option="{ description }">
                    {{ description }}
                  </template>
                </vue-select>
                <small class="text-danger" v-if="errors.length">{{ $t(`validation.${Object.keys(failedRules)[0]}`, {'_field_':$t('Language')}) }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group
                :label="$t('Tax number')"
                label-for="tax-number"
              >
                <b-form-input
                  :disabled="!taxType"
                  v-model="taxNum"
                  :placeholder="taxExample"
                  name="name"
                />
                <small v-if="taxExample">{{ $t('example') + ': ' + taxExample }}</small>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-button
              type="submit"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mt-2 mr-1"
              :disabled="invalid || !isValidNumber"
            >
              {{ $t('Save changes') }}
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import {
  ValidationProvider,
  ValidationObserver,
} from 'vee-validate/dist/vee-validate.full';
import {
  BButton, BForm, BFormGroup, BFormInput, BRow, BCol, BAlert, BCard, BCardText, BLink, BModal, VBModal
} from 'bootstrap-vue'
import VueSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import Apicall from '@/libs/api-call'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

// import International Telephone Input
import intlTelInput from '@/libs/intl-tel-input/js/intlTelInput.js';
import utilsScript from '@/libs/intl-tel-input/js/utils.js'
import '@/libs/intl-tel-input//css/intlTelInput.css';
// import locale
import Locale from '@/libs/locale.json'
import Taxids from '@/libs/stripe-supported-tax-ids.json'
import Fuse from 'fuse.js'

import VOtpInput from "@bachdgvn/vue-otp-input";


export default {
  components: {
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BAlert,
    BCard,
    BCardText,
    BLink,
    VueSelect,
    ValidationProvider,
    ValidationObserver,
    BModal,
    VBModal,
    VOtpInput,
    ToastificationContent,
  },
  directives: {
    Ripple,
  },
  props: {
    stripeInfosData: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      optionsLocal: this.stripeInfosData,
      taxOptions: [],
      country: '',
      region: '',
      cellContainer: {},
      taxId: this.stripeInfosData.tax_ids,
      taxType: null,
      taxNum: null,
      taxExample: null,
      phoneNumber: null,
      isValidNumber: true,
    }
  },
  watch: {
    taxType(val) {
      if (val) {
        this.taxOptions.filter(option => {
          if (option.value == val) {
            this.taxExample = option.example;
          }
        });
      }
    },
  },
  mounted() {
    this.getMyAccountGeneral();
  },
  methods: {
    getMyAccountGeneral() {
      this.getTaxOptions();
      this.generatePhoneNumber();
      if (this.optionsLocal.tax_ids.total_count > 0) {
        this.taxNum = this.optionsLocal.tax_ids.data[0].value;
      }
    },
    getTaxOptions() {
      this.taxOptions = [];
      var isSelected = false;
      Taxids.forEach(element => {
        this.taxOptions.push({"value": element.code + "|" + element.enum, "description": element.country + ' - ' + element.description, "example": element.example});
        if (this.optionsLocal.tax_ids.total_count > 0 && this.optionsLocal.tax_ids.data[0].type === element.enum) {
          this.taxType = element.code + "|" + element.enum;
          this.taxExample = element.example;
          isSelected = true;
        }
        if (!isSelected) this.taxType = '';
      });
    },
    generatePhoneNumber() {
      const inputPhone = document.querySelector("#phonestripe");
      this.cellContainer = intlTelInput(inputPhone, {
        utilsScript: utilsScript,
        autoPlaceholder: "aggressive",
        preferredCountries: ['fr','ca','be','us','mx'],
        initialCountry: "auto",
        autoPlaceholder: "off"
      });
      if (this.optionsLocal.phone) {
        if (this.optionsLocal.phone.charAt(0) == '+') {
          this.cellContainer.setNumber(this.optionsLocal.phone);
        } else {
          this.cellContainer.setNumber('+' + this.optionsLocal.phone);
        }
        
      }
    },
    fuseSearch(options, search) {
      const fuse = new Fuse(options, {
        keys: ['description'],
        shouldSort: true,
      })
      return search.length
        ? fuse.search(search).map(({ item }) => item)
        : fuse.list
    },
    validatePhoneNumber() {
      if (this.cellContainer.isValidNumber()) {
        this.phoneNumber = this.cellContainer.getNumber();
        this.optionsLocal.phone = this.phoneNumber;
        this.isValidNumber = true;
        this.$refs.phoneInput.classList.remove("is-invalid");
      } else {
        this.isValidNumber = false;
        this.$refs.phoneInput.classList.add("is-invalid");
      }
    },
    saveInfo() {
      this.validatePhoneNumber();
      this.$refs.updateBillingInfoForm.validate().then(success => {
        if (success && this.isValidNumber) {
          const api = new Apicall();
          const temp = this.taxType.split("|"); // split taxType to country and type
          var tax = {
            'country': temp[0],
            'type': temp[1],
            'value': this.taxNum
          };
          var address = this.optionsLocal.address;
          if (address.line1 === null && address.line2 === null && address.city === null && address.state === null && address.country === null && address.postal_code === null) {
            this.optionsLocal.address = null;
          }
          api.updateBillingInformation(this.optionsLocal, tax).then(response => {
            if (response.status === 'OK') { 
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  variant: 'success',
                  title: this.$t('message.oneFieldUpdatedSuccess', {'_field_':this.$t('Billing information')}),
                  icon: 'CheckIcon'
                },
              });
            } else {
              if (response.statuscode === 401) this.$router.push('Login');
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  variant: 'danger',
                  title: this.$t(response.msg),
                  icon: 'XIcon',
                },
              });
            }
          });        
        }
      });
    },
  }
}
</script>
<style scoped>
.form-group .iti{
  position: relative;
  display: flex;
}
.v-select.form-control{
  padding: 0rem;
}
</style>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>